<template>
  <div class="white-bg">
    <ul class="type-list">
      <router-link class="title active-link" tag="li" :to="{path:'/goods'}">全部分类</router-link>
      <router-link tag="li" :to="{path:'/index'}" class="active-link">商城首页</router-link>
      <router-link tag="li" :to="{path:'/search'}" class="active-link">拍兰花</router-link>
      <router-link tag="li" :to="{path:'/celebrity'}" class="active-link">名人介绍</router-link>
      <router-link tag="li" :to="{path:'/orchid'}" class="active-link">名兰介绍</router-link>
      <router-link tag="li" :to="{path:'/article'}" class="active-link">兰花文章</router-link>
      <router-link tag="li" :to="{path:'/friends'}" class="active-link">兰友圈</router-link>
      <router-link tag="li" :to="{path:'/shop'}" class="active-link">兰花店铺</router-link>
    </ul>
  </div>

</template>

<script>
export default {
  name: 'botNav',
    data(){
      return {

      }
    },
    components:{
    },
    computed: {

    },
    mounted(){

    },
    methods:{

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/css/common';
  .type-list{
    height:33px;
    line-height:33px;
    @include main-content;
    li{
      width:80px;
      float: left;
      color:#575757;
      font-size:16px;
      text-align: center;
      margin-left:24px;
      cursor: pointer;
      &:hover{color:$main-color;}
      &.active-link.router-link-exact-active,&.router-link-active{
        color:$main-color;
        font-weight:600;
      }
      &.title{
        background-color:$main-color;color: #ffffff;width:210px;
        line-height: 33px;margin-left:0;
        &.active-link.router-link-exact-active{
          font-weight:600;
          color: #ffffff;
        }
      }
    }
  }


</style>

